
import Button from '../../../components/base/Button';

export default function HonorsHeroSection() {
  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden">
      {/* 背景图片 */}
      <div 
        className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/4cfd584f3c5f53a615aedf80a60f5c2c.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* 内容容器 */}
      <div className="relative z-10 w-full h-full flex items-center justify-center px-4 sm:px-6 lg:px-[15%]">
        <div className="w-full max-w-6xl text-center text-white space-y-4 sm:space-y-6 lg:space-y-8">
          {/* 主标题 */}
          <div className="space-y-2 sm:space-y-3 lg:space-y-4">
            <h1 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#cc9966]" style={{ fontFamily: '"Trajan Pro", serif' }}>
              荣誉见证
            </h1>
            <p className="text-sm sm:text-lg lg:text-xl font-light">
              权威认证，实力见证品质
            </p>
          </div>

          {/* 核心荣誉展示 - 手机版优化 */}
          <div className="bg-black/30 backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-6 lg:p-10 border border-[#cc9966]/30 mx-auto max-w-5xl">
            <h2 className="text-sm sm:text-xl lg:text-2xl xl:text-3xl font-bold text-[#cc9966] mb-4 sm:mb-6 lg:mb-8">
              行业领先地位的权威认证
            </h2>
            
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4 lg:gap-6">
              {/* 普洱茶销量第一 */}
              <div className="flex flex-col items-center space-y-1 sm:space-y-2 lg:space-y-3 p-2 sm:p-4 lg:p-6 bg-white/10 rounded-lg sm:rounded-xl border border-[#cc9966]/30">
                <div className="w-8 h-8 sm:w-12 sm:h-12 lg:w-16 lg:h-16 flex items-center justify-center bg-[#cc9966] rounded-full">
                  <i className="ri-trophy-fill text-sm sm:text-lg lg:text-2xl text-white"></i>
                </div>
                <h3 className="text-xs sm:text-sm lg:text-base font-bold text-[#cc9966] text-center leading-tight">普洱茶年份茶</h3>
                <p className="text-xs sm:text-base lg:text-xl font-bold text-white">全国销量第一</p>
                <p className="text-xs sm:text-sm text-center text-gray-200 leading-tight">
                  尚普咨询权威认证
                </p>
              </div>

              {/* 国宾伴手礼 */}
              <div className="flex flex-col items-center space-y-1 sm:space-y-2 lg:space-y-3 p-2 sm:p-4 lg:p-6 bg-white/10 rounded-lg sm:rounded-xl border border-[#cc9966]/30">
                <div className="w-8 h-8 sm:w-12 sm:h-12 lg:w-16 lg:h-16 flex items-center justify-center bg-[#cc9966] rounded-full">
                  <i className="ri-medal-fill text-sm sm:text-lg lg:text-2xl text-white"></i>
                </div>
                <h3 className="text-xs sm:text-sm lg:text-base font-bold text-[#cc9966] text-center leading-tight">国宾伴手礼</h3>
                <p className="text-xs sm:text-base lg:text-xl font-bold text-white">指定认证</p>
                <p className="text-xs sm:text-sm text-center text-gray-200 leading-tight">
                  丝路沿线国家指定
                </p>
              </div>

              {/* 七星茶王奖 */}
              <div className="flex flex-col items-center space-y-1 sm:space-y-2 lg:space-y-3 p-2 sm:p-4 lg:p-6 bg-white/10 rounded-lg sm:rounded-xl border border-[#cc9966]/30">
                <div className="w-8 h-8 sm:w-12 sm:h-12 lg:w-16 lg:h-16 flex items-center justify-center bg-[#cc9966] rounded-full">
                  <i className="ri-star-fill text-sm sm:text-lg lg:text-2xl text-white"></i>
                </div>
                <h3 className="text-xs sm:text-sm lg:text-base font-bold text-[#cc9966] text-center leading-tight">七星茶王奖</h3>
                <p className="text-xs sm:text-base lg:text-xl font-bold text-white">最高荣誉</p>
                <p className="text-xs sm:text-sm text-center text-gray-200 leading-tight">
                  六堡茶斗茶大会
                </p>
              </div>

              {/* PICC承保 */}
              <div className="flex flex-col items-center space-y-1 sm:space-y-2 lg:space-y-3 p-2 sm:p-4 lg:p-6 bg-white/10 rounded-lg sm:rounded-xl border border-[#cc9966]/30">
                <div className="w-8 h-8 sm:w-12 sm:h-12 lg:w-16 lg:h-16 flex items-center justify-center bg-[#cc9966] rounded-full">
                  <i className="ri-shield-check-fill text-sm sm:text-lg lg:text-2xl text-white"></i>
                </div>
                <h3 className="text-xs sm:text-sm lg:text-base font-bold text-[#cc9966] text-center leading-tight">PICC承保</h3>
                <p className="text-xs sm:text-base lg:text-xl font-bold text-white">产品责任险</p>
                <p className="text-xs sm:text-sm text-center text-gray-200 leading-tight">
                  中国人民保险承保
                </p>
              </div>
            </div>
          </div>

          {/* 成就数据 */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 max-w-4xl mx-auto">
            <div className="text-center space-y-1 sm:space-y-2">
              <div className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966]">15+</div>
              <p className="text-xs sm:text-base text-gray-200">权威认证</p>
            </div>
            <div className="text-center space-y-1 sm:space-y-2">
              <div className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966]">50+</div>
              <p className="text-xs sm:text-base text-gray-200">行业奖项</p>
            </div>
            <div className="text-center space-y-1 sm:space-y-2">
              <div className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966]">5</div>
              <p className="text-xs sm:text-base text-gray-200">国家级荣誉</p>
            </div>
            <div className="text-center space-y-1 sm:space-y-2">
              <div className="text-xl sm:text-3xl lg:text-4xl font-bold text-[#cc9966]">100%</div>
              <p className="text-xs sm:text-base text-gray-200">质量合格率</p>
            </div>
          </div>
        </div>
      </div>

      {/* 滚动提示 */}
      <div className="absolute bottom-6 lg:bottom-8 left-1/2 transform -translate-x-1/2 text-white/60 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-xl"></i>
        </div>
      </div>
    </section>
  );
}
